import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { createTheme } from "./theme";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@mui/material";
import { DialogProvider } from "./contexts/DialogContext";

const queryClient = new QueryClient();

const theme = createTheme();

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://4c21a33007a3acec7c7fd1da21657135@o4510867329384448.ingest.de.sentry.io/4510867331154000",
  sendDefaultPii: true,
});

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

createRoot(rootEl).render(
    <StrictMode>
      <BrowserRouter>
          <ThemeProvider theme={theme}>
              <QueryClientProvider client={queryClient}>
                <DialogProvider>
                  <App />
                </DialogProvider>
              </QueryClientProvider>
          </ThemeProvider>
      </BrowserRouter>
    </StrictMode>,
);
